import React, { useMemo } from 'react'

import ListPageHeader from '@shared/ListPageHeader'
import OrderSerialNumbersList from '@shared/orders/OrderSerialNumbersList'
import { orderService } from '@services/admin/orderService'

export default function AdminOrderSerialNumbersList() {
  // Create a service wrapper that maps getSerialNumbers to getRecords
  // This is required because TableIndex expects a service with getRecords method
  const serialNumbersService = useMemo(() => ({
    getRecords: (params) => orderService.getSerialNumbers(params),
  }), [])

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['orders', 'orders.serial_numbers']}
      />
      <OrderSerialNumbersList
        service={serialNumbersService}
        role="admin"
      />
    </div>
  )
}
